import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { EmptyState } from "@/components/empty-state";
import { Button } from "@/components/ui/button";

export default function NotFoundRoute() {
  return (
    <main className="min-h-full bg-bg">
      <EmptyState
        icon={Compass}
        title="Off the map"
        body="This page doesn't exist. Or it moved. Either way — back to your trips."
        cta={
          <Button asChild>
            <Link to="/dashboard">Back to trips</Link>
          </Button>
        }
      />
    </main>
  );
}
